<template>
	<div>
		<div class="row mb-2">
			<div class="col-sm-4">
				<router-link :to="{ name: 'PortfolioAdd' }" class="btn btn-danger btn-rounded mb-3">
					<i class="mdi mdi-plus"></i> Создать проект
				</router-link>
			</div>
			<div class="col-sm-8">
				<div class="text-sm-right">
					<div class="btn-group mb-3 mr-2">
						<button type="button" class="btn" :class="filter.show === null ? 'btn-primary' : 'btn-light'" @click="filter.show = null">Все</button>
						<button type="button" class="btn" :class="filter.show === true ? 'btn-primary' : 'btn-light'" @click="filter.show = true">Показанные на сайте</button>
						<button type="button" class="btn" :class="filter.show === false ? 'btn-primary' : 'btn-light'" @click="filter.show = false">Скрытые</button>
					</div>

					<div class="btn-group mb-3">
						<button type="button" class="btn" :class="filter.deleted === false ? 'btn-light' : 'btn-primary'" @click="filter.deleted = !filter.deleted">Удаленные</button>
					</div>
				</div>
			</div><!-- end col-->
		</div> 
		<!-- end row-->

		<div class="row" v-if="!items.length">
			<div class="col-md-12 text-center">
				<div class="spinner-grow" role="status">
					<span class="sr-only">Loading...</span>
				</div>
			</div>
		</div>

		<div class="row" v-else>

			<div class="col-md-6 col-xl-3" v-for="item in filteredItems">
				<!-- project card -->
				<div class="card d-block" v-if="!item.cover || !item.cover.path">
					<div class="card-body">
						 <div class="dropdown card-widgets">
							<a href="#" class="dropdown-toggle arrow-none" data-toggle="dropdown" aria-expanded="false">
								<i class="dripicons-dots-3"></i>
							</a>
							<div class="dropdown-menu dropdown-menu-right">
								<router-link :to="{ name: 'PortfolioEdit', params: { id: item._id } }" class="dropdown-item"><i class="mdi mdi-pencil mr-1"></i>Редактировать</router-link>
							   
								<a href="#" v-if="!item.deleted" class="dropdown-item" @click.prevent="deleteItem(item._id)"><i class="mdi mdi-delete mr-1"></i>Удалить</a>
								<a href="#" v-else class="dropdown-item" @click.prevent="restoreItem(item._id)"><i class="mdi mdi-delete-restore mr-1"></i>Восстановить</a>
							</div>
						</div>

						<!-- project title-->
						<h4 class="mt-0">
							<router-link :to="{ name: 'PortfolioEdit', params: { id: item._id } }" class="text-title">{{ item.name }}</router-link>
						</h4>
						<div class="badge mb-3 mr-1 badge-danger" v-if="item.deleted">Удален</div>
						<div class="badge mb-3" :class="item.show ? 'badge-success' : 'badge-secondary'">
							<span v-if="item.show">Показан на сайте</span>
							<span v-else>Скрыт</span>
						</div>
					</div>
				</div>

				<div class="card d-block" v-else>
					<img class="card-img-top" :src="app_cdn_host +'/i/w=500/_/'+ item.cover.path" alt="project image cap">

				<router-link :to="{ name: 'PortfolioEdit', params: { id: item._id } }" class="text-title">
					<div class="card-img-overlay">
						<div class="badge p-1 mr-1 badge-danger" v-if="item.deleted">Удален</div>
						<div class="badge p-1" :class="item.show ? 'badge-success' : 'badge-secondary'">
							<span v-if="item.show"><i class="mdi mdi-eye mr-1"></i> Показан на сайте</span>
							<span v-else><i class="mdi mdi-eye-off mr-1"></i> Скрыт</span>
						</div>
						<div v-if="item.pinned" class="badge p-1 badge-info ml-2">
							<i class="mdi mdi-pin mr-1"></i> Закреплен на главной
						</div>
					</div>
				</router-link>

					<div class="card-body position-relative">
						<div class="dropdown card-widgets">
							<a href="#" class="dropdown-toggle arrow-none" data-toggle="dropdown" aria-expanded="false">
								<i class="dripicons-dots-3"></i>
							</a>
							<div class="dropdown-menu dropdown-menu-right">
								<router-link :to="{ name: 'PortfolioEdit', params: { id: item._id } }" class="dropdown-item"><i class="mdi mdi-pencil mr-1"></i>Редактировать</router-link>

								<a href="#" v-if="!item.show" class="dropdown-item" @click.prevent="showItem(item._id, true)"><i class="mdi mdi-eye mr-1"></i>Показать на сайте</a>
								<a href="#" v-else class="dropdown-item" @click.prevent="showItem(item._id, false)"><i class="mdi mdi-eye-off mr-1"></i>Скрыть</a>

								<a href="#" v-if="!item.pinned" class="dropdown-item" @click.prevent="pinItem(item._id, true)"><i class="mdi mdi-pin mr-1"></i>Закрепить на главной</a>
								<a href="#" v-else class="dropdown-item" @click.prevent="pinItem(item._id, false)"><i class="mdi mdi-pin-off mr-1"></i>Убрать с главной</a>
								
								<a href="#" v-if="!item.deleted" class="dropdown-item" @click.prevent="deleteItem(item._id)"><i class="mdi mdi-delete mr-1"></i>Удалить</a>
								<a href="#" v-else class="dropdown-item" @click.prevent="restoreItem(item._id)"><i class="mdi mdi-delete-restore mr-1"></i>Восстановить</a>
							</div>
						</div>

						<h4 class="mt-0">
							<router-link :to="{ name: 'PortfolioEdit', params: { id: item._id } }" class="text-title">{{ item.name }}</router-link>
						</h4>

						<p class="mb-1">
							<span class="pr-2 text-nowrap mb-2 d-inline-block">
								Фотографий <b>{{ item.photos.length }}</b>
							</span>
							<span class="pr-2 text-nowrap mb-2 d-inline-block">
								Видео <b>{{ item.videos.length }}</b>
							</span>
							<span class="pr-2 text-nowrap mb-2 d-inline-block">
								Статей <b>{{ item.articles.length }}</b>
							</span>
							<span class="text-nowrap mb-2 d-inline-block">
								Просмотров <b>{{ item.views }}</b>
							</span>
						</p>
					</div>

				</div>
			</div>

		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import log from '@/plugins/log'
import { to } from '@/plugins/utils'

export default {
	name: 'PortfolioList',
	data: () => {
		return {
			items: [],
			filter: {
				show: null,
				deleted: false
			}
		}
	},
	computed: {
		...mapState([
			'app_cdn_host'
		]),
		filteredItems() {
			return this.items.filter(item => {
				if(this.filter.deleted === false && item.deleted) return false

				if(this.filter.show === null) return true
				if(this.filter.show === item.show) return true

				return false
			})
		}
	},
	beforeMount() {
		this.getData()
	},
	mounted() {
		log.debug('/views/portfolio/list', 'mounted')
	},
	methods: {
		async getData() {
			var [err, response] = await to( this.$http.get('/portfolio/list') )
			if(err) {
				log.error('/views/portfolio/list', 'methods.getData', '$http.request', err)
				return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
			}
			log.debug('/views/portfolio/list', 'methods.getData', '$http.request', response.data)

			this.items = response.data.items
		},

		async showItem(id, status) {
			var [err, response] = await to( this.$http.post(`/portfolio/edit/${id}`, {show: !!status}) )
			if(err) {
				log.error('/views/portfolio/list', 'methods.showItem', '$http.request', err)
				return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
			}
			if(!response.data.success) {
				log.error('/views/portfolio/list', 'methods.showItem', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}
			log.debug('/views/portfolio/list', 'methods.showItem', '$http.request', response.data)

			this.getData()
		},

		async pinItem(id, status) {
			var [err, response] = await to( this.$http.post(`/portfolio/edit/${id}`, {pinned: !!status}) )
			if(err) {
				log.error('/views/portfolio/list', 'methods.pinItem', '$http.request', err)
				return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
			}
			if(!response.data.success) {
				log.error('/views/portfolio/list', 'methods.pinItem', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}
			log.debug('/views/portfolio/list', 'methods.pinItem', '$http.request', response.data)

			this.getData()
		},

		async deleteItem(id) {
			if(!confirm('Уверены, что хотите удалить?')) return;

			var [err, response] = await to( this.$http.post(`/portfolio/delete/${id}`) )
			if(err) {
				log.error('/views/portfolio/list', 'methods.deleteItem', '$http.request', err)
				return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
			}
			if(!response.data.success) {
				log.error('/views/portfolio/list', 'methods.deleteItem', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}
			log.debug('/views/portfolio/list', 'methods.deleteItem', '$http.request', response.data)

			this.getData()
		},
		async restoreItem(id) {
			var [err, response] = await to( this.$http.post(`/portfolio/restore/${id}`) )
			if(err) {
				log.error('/views/portfolio/list', 'methods.restoreItem', '$http.request', err)
				return $.NotificationApp.send("Ошибка", "Не удалось получить данные", "top-right", "", "error")
			}
			if(!response.data.success) {
				log.error('/views/portfolio/list', 'methods.restoreItem', '$http.response', response.data)
				return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
			}
			log.debug('/views/portfolio/list', 'methods.restoreItem', '$http.request', response.data)

			this.getData()
		}
	}
};
</script>